const state = {
  // 登录的用户信息
  userLoginedInfo: {
    userNo: '' // 用户名
  },
  token: '',
  registStep: '', //注册到第几部了
  workDynamicsmEenus:{
    defaultActive: '0',
    subtitle: '新闻动态'
  }, //记录工作动态menus
  testEvaluationMenu:{
    type: '0',
    subtitle: '产业论坛'
  }, //产业服务
}
export default state



// WEBPACK FOOTER //
// ./src/store/state.js